import { Typography, Box, Button, Card, Grid } from "@mui/material";
import React from "react";
import theme from "../../utils/theme";
import ApiService from "../../api_service/api_service";
import { Link } from "react-router-dom";
import {priceSplitor} from "../../core/price_splitor";

const RelatedPhones = (props) => {
    const offset = props.props.offset ?? 10;
    const categoryId = props.props.categoryId;
    const brandId = props.props.brandId;
    const product = props.props.product;
    const [ phoneList, setPhoneList ] = React.useState([]);

    React.useEffect(() => {
        const getPhoneList = async () => {
            if(product) {
                let response = await ApiService.productsByCategory(product.brand?._id, product.category?._id);
                const filteredList = response.data.docs.filter(p => p._id != product._id)
                setPhoneList(filteredList);
            }
    
        };

        getPhoneList();

    }, [product]);

    return (
        <Box sx={{ width: '100%', overflow: 'hidden', bgcolor: 'white' }}>
            <Box sx={{ display: 'flex', gap: '20px', overflowX: 'scroll', padding: '10px' }}>
            {
                    phoneList.map((phone, index) => (
                        <Card key={index}
                                sx={{
                                    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.3)',
                                    height: '100%',
                                    minWidth: '230px',
                                    maxWidth: '230px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    borderRadius: '8px',
                                }}
                                
                            >
                                <Box sx={{
                                    textAlign: 'center',
                                    p: '16px',
                                }}
                                
                                component={Link}
                                to={`/product-detail?id=${phone._id}`}
                                >
                                    <img
                                        alt='Header Icon'
                                        loading="lazy"
                                        src={ ApiService.basedPublicURL + phone.thumbnail}
                                        style={{ height: '128px', width: '100%', objectFit: 'cover' }}
                                    />
                                </Box>
                                <Box sx={{
                                    px: '20px',
                                    pb: '20px',
                                    height: '120px',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    flexDirection: 'column',
                                }}>
                                    <Typography
                                     sx={{
                                        fontSize: '16px',
                                        fontWeight: 500,
                                    }}
                                    >{phone.brand.name}</Typography>
                                    <Typography sx={{
                                        fontWeight: 500,
                                    }}
                                    >{phone.name}</Typography>
                                    <Typography sx={{
                                        textAlign: 'end',
                                        color: '#EC1D25',
                                        fontWeight: 700,
                                        fontSize: '16px'
                                    }}>{ priceSplitor(phone.price) } Ks</Typography>
                                    <Typography sx={{
                                        textAlign: 'end',
                                        color: theme.palette.primary.main
                                    }}>{phone.remark}</Typography>
                                    
                                </Box>
                                
                            </Card>
                    ))
                }
            </Box>
        </Box>
    )
}

export default RelatedPhones